export function getLenguageCode(language: string) {
  if (language === "es") return "es-MX";

  return "en-US";
}